AngularService = App.loadClass 'core::Angular/Service'

class exports.Service extends AngularService
    constructor: (@http) ->
        undefined

    fetchAdvisorRequest: () =>
        return @http.get 'backend/grower/advisor-request/fetch'
            .then (result) ->
                return result.data

    saveAdvisorRequest: (requests) =>
        return @http.post 'backend/grower/advisor-request/save',
            requests: requests
